import { Typography } from '@mui/material';
import { SectionContainerContent } from './section-container.component';
import { useClinicalNotesContext } from '../clinical-notes.context';
import { useFollowUpAppointmentDate } from '@uplift/ui-v2';
import { useMemo } from 'react';
import { useSectionStyles } from '../sections/styles';
import { useL10n } from '@uplift/hooks';

export const FollowUpContentBlock = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();
  const { state: { appointment } } = useClinicalNotesContext();
  const { dateOfNextAppointment, loading } = useFollowUpAppointmentDate(appointment.id);

  const date = useMemo(() => {
    if (loading) return null;
    if (!dateOfNextAppointment) return l10n.clinicalNotes.clientScheduleNextAppointment;
    return l10n.clinicalNotes.nextAppointment(
      dateOfNextAppointment.date,
      dateOfNextAppointment.time,
      dateOfNextAppointment.meridiem
    );
  }, [ dateOfNextAppointment, l10n.clinicalNotes, loading ]);

  return (
    <SectionContainerContent>
      <Typography color="textSecondary">
        <Typography className={classes.fontWeight500} component="span">
          {l10n.clinicalNotes.followUp}
        </Typography>
        :&nbsp;{date}
      </Typography>
    </SectionContainerContent>
  );
};
